import { j as i } from "./atoms-v218.js";
import { forwardRef as k } from "react";
import { RateCardContainer as B, RateMainHeader as _, RateMainTitle as u, RateMainSubtitle as P, RateMainStrikeThroughPrice as g, RateMainPrice as F, ViewRateDetailsLink as L, RatesSection as T, RateSectionHeader as b, RateSectionTitle as w, ViewDetailsLink as D, RateCardsWrapper as H, RateCard as A, RateCardHeader as M, RateCardPriceSection as $, RateCardPrice as p, RateCardPriceText as C, RateCardTitle as S, RateCardDescription as v, AdditionalRatesButton as E, AdditionalRatesButtonText as I, ButtonFooter as K, ButtonGroup as V, FooterButton as z, ButtonFooterText as G } from "./atoms-v21033.js";
import { useBreakpoints as N } from "./atoms-v251.js";
import { Icon as U } from "./atoms-v217.js";
import { PaymentButton as W } from "./atoms-v21029.js";
function q(o) {
  return "brand" in o;
}
const J = ({
  colorTheme: o,
  currentRate: e,
  language: n,
  onPriceBreakdownClick: r,
  roomName: c,
  totalAddonPrice: l,
  translations: x
}) => /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsxs(_, { children: [
  /* @__PURE__ */ i.jsx(u, { $colorTheme: o, children: c }),
  /* @__PURE__ */ i.jsxs(P, { children: [
    ((e == null ? void 0 : e.discount_after_tax) || 0) > 0 && /* @__PURE__ */ i.jsx(g, { $colorTheme: o, children: e == null ? void 0 : e.discount_after_tax.toLocaleString(n, {
      currency: e == null ? void 0 : e.currency_code,
      style: "currency"
    }) }),
    /* @__PURE__ */ i.jsx(F, { $colorTheme: o, children: ((e == null ? void 0 : e.total_after_tax) + l).toLocaleString(n, {
      currency: e == null ? void 0 : e.currency_code,
      style: "currency"
    }) }),
    /* @__PURE__ */ i.jsx(L, { renderAsButton: !0, $colorTheme: o, onClick: r, children: x.priceBreakdownLink })
  ] })
] }) }), O = ({
  colorTheme: o,
  currentRate: e,
  language: n,
  onAdditionalRatesAndPackagesClick: r,
  onRateDetailsClick: c,
  rates: l,
  setCurrentRate: x,
  translations: t
}) => {
  var m;
  const { current: y } = N(), a = (e == null ? void 0 : e.id) === ((m = l.slice(0, 2).at(-1)) == null ? void 0 : m.id);
  function j(s) {
    return {
      onKeyDown(d) {
        (d.key === "Enter" || d.key === " ") && d.preventDefault(), d.key === "Enter" && s();
      },
      onKeyUp(d) {
        d.key === " " && s();
      }
    };
  }
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsxs(T, { children: [
    /* @__PURE__ */ i.jsxs(b, { children: [
      /* @__PURE__ */ i.jsx(w, { $colorTheme: o, children: t.ratesAndPackagesTitle }),
      /* @__PURE__ */ i.jsx(D, { renderAsButton: !0, $colorTheme: o, onClick: c, children: t.viewRateDetailsLink })
    ] }),
    /* @__PURE__ */ i.jsxs(H, { children: [
      l.slice(0, 2).map((s, d) => {
        const h = (e == null ? void 0 : e.id) === s.id, f = d > 0 && (e == null ? void 0 : e.id) === l[d - 1].id;
        return /* @__PURE__ */ i.jsxs(
          A,
          {
            $colorTheme: o,
            $isFirst: d === 0,
            $isPreviousSelected: f,
            $isSelected: h,
            onClick: () => x(s),
            role: "button",
            tabIndex: 0,
            ...j(() => x(s)),
            children: [
              /* @__PURE__ */ i.jsx(M, { children: y === "small" ? /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                /* @__PURE__ */ i.jsxs($, { children: [
                  /* @__PURE__ */ i.jsx(p, { $colorTheme: o, children: s.nightly_after_tax.toLocaleString(n, {
                    currency: s.currency_code,
                    style: "currency"
                  }) }),
                  /* @__PURE__ */ i.jsxs(C, { $colorTheme: o, children: [
                    "/ ",
                    t.night
                  ] })
                ] }),
                /* @__PURE__ */ i.jsx(S, { $colorTheme: o, children: s.name })
              ] }) : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                /* @__PURE__ */ i.jsx(S, { $colorTheme: o, children: s.name }),
                /* @__PURE__ */ i.jsxs($, { children: [
                  /* @__PURE__ */ i.jsx(p, { $colorTheme: o, children: s.nightly_after_tax.toLocaleString(n, {
                    currency: s.currency_code,
                    style: "currency"
                  }) }),
                  /* @__PURE__ */ i.jsxs(C, { $colorTheme: o, children: [
                    "/ ",
                    t.night
                  ] })
                ] })
              ] }) }),
              /* @__PURE__ */ i.jsx(v, { $colorTheme: o, lineClamp: 2, children: s.description })
            ]
          },
          s.id
        );
      }),
      /* @__PURE__ */ i.jsxs(
        E,
        {
          $isPreviousSelected: a,
          onClick: r,
          role: "button",
          tabIndex: 0,
          ...j(r),
          children: [
            /* @__PURE__ */ i.jsx(I, { $colorTheme: o, children: t.additionalRatesAndPackagesLabel }),
            /* @__PURE__ */ i.jsx(U, { name: "chevron-right", size: "medium" })
          ]
        }
      )
    ] })
  ] }) });
}, Q = ({ colorTheme: o, footer: e }) => /* @__PURE__ */ i.jsxs(K, { children: [
  /* @__PURE__ */ i.jsx(V, { children: e.footerButtons.map(
    (n, r) => q(n) ? /* @__PURE__ */ i.jsx(W, { ...n }, `footer-button-${r}`) : /* @__PURE__ */ i.jsx(z, { ...n }, `footer-button-${r}`)
  ) }),
  /* @__PURE__ */ i.jsx(G, { $colorTheme: o, children: e.footer })
] }), X = k(
  ({
    className: o,
    colorTheme: e = "light",
    currentRateId: n,
    footer: r,
    language: c = "en",
    onAdditionalRatesAndPackagesClick: l,
    onPriceBreakdownClick: x,
    onRateChange: t,
    onRateDetailsClick: y,
    rates: a,
    roomName: j,
    totalAddonPrice: m = 0,
    translations: s
  }, d) => {
    const h = a.find((f) => f.id === n) ?? a[0];
    return h ? /* @__PURE__ */ i.jsxs(B, { className: o, ref: d, children: [
      /* @__PURE__ */ i.jsx(
        J,
        {
          colorTheme: e,
          currentRate: h,
          language: c,
          onPriceBreakdownClick: x,
          roomName: j,
          totalAddonPrice: m,
          translations: s
        }
      ),
      /* @__PURE__ */ i.jsx(
        O,
        {
          colorTheme: e,
          currentRate: h,
          language: c,
          onAdditionalRatesAndPackagesClick: l,
          onRateDetailsClick: y,
          rates: a,
          setCurrentRate: t,
          translations: s
        }
      ),
      /* @__PURE__ */ i.jsx(Q, { colorTheme: e, footer: r })
    ] }) : null;
  }
);
X.displayName = "RateCard";
export {
  X as RateCard
};
